import { useForm } from "react-hook-form";
import { Button } from "../components/button";
import {
  ComponentTabLink,
  ITabLink,
  ITabTitle,
} from "../components/component-tab";
import { FormError2 } from "../components/form-error";
import { ICrPortFormProps, useCrPort } from "../hooks/useCrPort";
import { AsideAdminComponent } from "../layout/aside-admin";
import { CrPortInput, CrPortMutation } from "../generated/graphql";

export const AdminCrPort = () => {
  const {
    getValues,
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<ICrPortFormProps>({ mode: "all" });

  const onComplete = async (data: CrPortMutation) => {
    const {
      crPort: { ok, err },
    } = data;
    if (ok) {
      // alert("저장되었습니다");
      window.location.href = `/port`;
    } else {
      alert(err);
    }
  };

  const [crPort, { loading }] = useCrPort(onComplete);
  const onSubmit = () => {
    if (!loading) {
      const { name, projectId } = getValues();
      const crPortInput: CrPortInput = {
        name,
        projectId,
      };
      crPort({ variables: { input: crPortInput } });
    }
  };
  const tabList: ITabLink[] = [];

  const stitle: ITabTitle = { text: "포트 등록" };

  return (
    <div className="bg-main bg-opacity-50 w-full h-full min-h-screen">
      <div className="w-full mx-auto h-full min-h-screen bg-white">
        <main id="main">
          <div className="grid grid-cols-[200px_1fr]">
            <AsideAdminComponent />

            <div className="mypages bg-gray-100">
              <div className="orderWrap">
                <div className="bg-gray-100 h-fix-content relative">
                  <div className={`w-full h-full px-10 py-8`}>
                    <ComponentTabLink tabs={tabList} stitle={stitle} />
                    <div className="shadow-lg min-w-[1160px] max-w-[1160px]  2xl:max-w-[1623px]  bg-white">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="pl-9 pr-11 py-8 space-y-4">
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              이름
                            </p>
                            <input
                              {...register("name", {
                                required: `이름을 입력해주세요`,
                              })}
                              type="text"
                              className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                            />
                            {errors.name?.message && (
                              <FormError2 errorMessage={errors.name.message} />
                            )}
                          </div>

                          <div className="flex flex-wrap justify-center pt-6">
                            <Button
                              className={`w-[240px] h-[40px] bg-[#3D3E49] text-white rounded-lg`}
                              canClick={true}
                              actionText={`등록`}
                              loading={loading}
                              color={"text-white"}
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
